// assets/baby-poster-palette.js
(function (root) {
  root.BabyPosterPalette = root.BabyPosterPalette || {};

  // You can edit ONLY this list to add/remove colors.
  root.BabyPosterPalette.colors = [
   { name: "Grey",   hex: "#ebebeb", default: true },
   { name: "Beige",  hex: "#f2eedf" },
   { name: "Yellow", hex: "#FFF6D6"},
   { name: "Greige", hex: "#d0ccc1" },
   { name: "Light pink", hex: "#F9E9E9"},
   { name: "Pink",   hex: "#d9c5bc" },
   { name: "Pink Blush", hex: "#e1d4c4" },
   { name: "Light blue", hex: "#d6eaf1"},
   { name: "Terra cotta", hex: "#d39377"},
   { name: "Green", hex: "#9baf8b"},
   { name: "Brown", hex: "#C7B190"},
   { name: "White", hex: "#ffffff"}
  ];
})(typeof self !== "undefined" ? self : this);
